import React from 'react'

const Shimmer = () => {
  return (
    <div className="shimmer-container py-3 m-1 flex flex-wrap bg-slate-100 rounded-lg">
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
            <div className="shimmer-cards bg-gray-200 hover:bg-gray-300 m-4 p-4 w-[270px] h-[350px] rounded-lg"></div>
    </div>
  )
}

export default Shimmer
